import {useContext, useEffect, useRef, useState} from "react";
import {QuotationContext} from "../../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../../model/quotation";
import {SalesProgramOption} from "../../../../model/quoationPackage";
import {VehicleType} from "../../../../model/vehicle";
import {Duration} from "../../../../model/contract";
import {PartyType} from "../../../../model/party";
import moment from "moment";


export const useMtlPackageSelect = (packages) => {
    const {
        quotation,
        selectedDeductible, setSelectedDeductible,
        selectedPackage, setSelectedPackage,
        selectedProgram, setSelectedProgram,
        setSelectedVtplPremium,
        selectedVtplCovered, setSelectedVtplCovered,
        selectedVtplSumInsured, setSelectedVtplSumInsured,
        selectedVtplPremium,
        tarrificationProgram,
        saveTempValues
    } = useContext<QuotationContext<MtplQuotation>>(QuotationContext);

    const [vtplError, setVtplError] = useState(false);
    const [scrollToVTPLSelectBlock, setScrollToVTPLSelectBlock] = useState(false);
    const [scrollToSalesOptions, setScrollToSalesOptions] = useState(false);

    let refVTPLSelectBlock = useRef(null);
    let refSalesOptions = useRef(null);

    useEffect(() => {
        let event = () => {
            switch (tarrificationProgram) {
                case 'mtpl_online_00001_smart_drive':
                    return 'osago_emtpl_smart_calculating';
                case 'mtpl_online_00001':
                    return 'osago_calculating';
                case 'greenCard_0001':
                    return 'green_card_calculating';
            }
        };
        console.log('Google Analytics Event = ' + event());
        // @ts-ignore
        window.dataLayer.push({'event': event()});
    }, []);

    useEffect(() => {
        if (scrollToSalesOptions) {
            window.scrollTo({behavior: 'smooth', top: refSalesOptions.current.offsetTop});
            setScrollToSalesOptions(false);
        }

        if (scrollToVTPLSelectBlock) {
            window.scrollTo({behavior: 'smooth', top: refVTPLSelectBlock.current.offsetTop});
            setScrollToVTPLSelectBlock(false);
        }

    }, [scrollToVTPLSelectBlock, scrollToSalesOptions]);

    const onDeductibleChangeListener = (obj: string) => {
        setSelectedDeductible(parseInt(obj));
        setSelectedPackage(packages.find(value => {
                return value.deductible === parseInt(obj);
            })
        );
        setSelectedProgram(undefined);
    };

    const onSalesProgramOptionSelect = (option: SalesProgramOption) => {
        setSelectedProgram(option);
        saveTempValues('selectedProgram', JSON.stringify(option));
    };

    const VTPLIsHidden = () => {
        if (selectedProgram === undefined) return true;
        if ([VehicleType.A1, VehicleType.A2].includes(quotation.mtplContract.vehicle.vehicleType)) return true;
        if (quotation.mtplContract.vehicle.taxiUsage) return true;
        if ([Duration.DAYS_15, Duration.MONTH_1, Duration.MONTHS_2].includes(quotation.mtplContract.duration)) return true;
    }

    const MTPLIsHidden = () => {
        return false
    }

    const CASCOIsHidden = () => {
        if (![VehicleType.B1, VehicleType.B2, VehicleType.B3_1, VehicleType.B3_2, VehicleType.B4, VehicleType.B5].includes(quotation.mtplContract.vehicle.vehicleType)) return true;
        if (PartyType.ORGANIZATION === quotation.mtplContract.vehicle.ownerPartyType) return true;
        if (moment().year() - 14 > quotation.mtplContract.vehicle.constructionYear) return true;
        if (quotation.mtplContract.vehicle.taxiUsage) return true;
        if (quotation.mtplContract.duration !== Duration.YEAR_1) return true;
    }

    return {
        selectedDeductible,
        quotation,
        selectedPackage,
        selectedProgram,
        refVTPLSelectBlock,
        refSalesOptions,
        onDeductibleChangeListener,
        onSalesProgramOptionSelect,
        setScrollToVTPLSelectBlock,
        setScrollToSalesOptions,
        vtplError,
        setVtplError,
        MTPLIsHidden,
        CASCOIsHidden,
        VTPLIsHidden,
        selectedVtplSumInsured,
        setSelectedVtplSumInsured,
        selectedVtplPremium,
        setSelectedVtplPremium,
        selectedVtplCovered,
        setSelectedVtplCovered
    }
}
